import { initializeApp } from 'firebase/app';
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import { GoogleAuthProvider, initializeAuth, browserLocalPersistence, getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getMessaging, isSupported, Messaging } from "firebase/messaging";

// Replace these values with your own Firebase configuration from the Firebase Console
const firebaseConfig = {
    apiKey: "AIzaSyCKFqO0TARxfz3zZd1G4ixCwAafvHBjUrY",
    authDomain: "standup-fb136.firebaseapp.com",
    projectId: "standup-fb136",
    storageBucket: "standup-fb136.firebasestorage.app",
    messagingSenderId: "207380369862",
    appId: "1:207380369862:web:2d53663813b606692322c7",
    measurementId: "G-6KFVJX9XK6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with Offline Persistence enabled
// Note: We avoid persistentMultipleTabManager in native environments (Tauri/Capacitor)
// to prevent deadlocks between multiple webview processes (Main vs Tray).
export const db = initializeFirestore(app, {
    localCache: persistentLocalCache({})
});

// Initialize Auth conditionally based on platform
let authInstance: any;
const isNativeMobile = typeof window !== 'undefined' && (window as any).Capacitor?.isNativePlatform?.();

if (isNativeMobile) {
    authInstance = initializeAuth(app, { persistence: browserLocalPersistence });
} else {
    authInstance = getAuth(app);
}

export const auth = authInstance;
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app);
